import React from 'react'

export default function StepComplted() {
  return (
    <div>
      complted order
    </div>
  )
}
